export { fireLegacyEvent } from './legacy-event';
